// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3117e","amount":"Amount_amount__11xTa","tip":"Amount_tip__3Wv_k","tipHeader":"Amount_tipHeader__1iPln","tipsWrap":"Amount_tipsWrap__3Av7A"};